export default __webpack_public_path__ + "images/507ac7b18e7a58407e337fdbe86f1a7e.png";